import React from 'react';
export function Footer() {
  return <footer className="bg-navy pt-20 pb-28 md:pb-20 px-6 border-t-8 border-yellow" data-id="element-140">
      <div className="max-w-7xl mx-auto" data-id="element-141">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-142">
          {/* Brand & Contact */}
          <div className="space-y-6" data-id="element-143">
            <div className="bg-white p-4 rounded-xl inline-block" data-id="element-144">
              <img src="https://cdn.magicpatterns.com/uploads/m2iaJxuvBKmSx3RYaxavga/Funtastic-kidz-01.svg" alt="Funtastic Kidz Early Learning Centre" className="h-12 w-auto" data-id="element-145" />
            </div>
            <div className="space-y-3 text-white/80 text-sm font-medium" data-id="element-146">
              <p className="font-bold text-white text-base" data-id="element-147">
                Funtastic Kidz Early Learning Centre
              </p>
              <p data-id="element-148">
                4 Brightfield Street,
                <br data-id="element-149" />
                Wyndham Vale VIC 3024
              </p>
              <p className="pt-2" data-id="element-150">
                <a href="tel:0387143350" className="hover:text-yellow transition-colors flex items-center gap-2" data-id="element-151">
                  <span className="font-bold text-white" data-id="element-152">Phone:</span> 03 8714
                  3350
                </a>
              </p>
              <p data-id="element-153">
                <a href="mailto:wyndham@funtastickidz.vic.edu.au" className="hover:text-yellow transition-colors flex items-center gap-2" data-id="element-154">
                  <span className="font-bold text-white" data-id="element-155">Email:</span>{' '}
                  wyndham@funtastickidz.vic.edu.au
                </a>
              </p>
              <p className="pt-2 font-bold text-white" data-id="element-156">
                Hours: Mon-Fri 6:30am-6:30pm
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-157">
            <h4 className="font-extrabold text-white mb-6 text-lg" data-id="element-158">Explore</h4>
            <ul className="space-y-4 text-sm font-medium text-white/70" data-id="element-159">
              <li data-id="element-160">
                <a href="#" className="hover:text-yellow transition-colors" data-id="element-161">
                  Home
                </a>
              </li>
              <li data-id="element-162">
                <a href="#programs" className="hover:text-yellow transition-colors" data-id="element-163">
                  Programs
                </a>
              </li>
              <li data-id="element-164">
                <a href="#why-us" className="hover:text-yellow transition-colors" data-id="element-165">
                  Why Us
                </a>
              </li>
              <li data-id="element-166">
                <a href="#fees" className="hover:text-yellow transition-colors" data-id="element-167">
                  Fees & CCS
                </a>
              </li>
              <li data-id="element-168">
                <a href="#3-day-guarantee" className="hover:text-yellow transition-colors" data-id="element-169">
                  3 Day Guarantee
                </a>
              </li>
              <li data-id="element-170">
                <a href="#tours" className="hover:text-yellow transition-colors" data-id="element-171">
                  Tours
                </a>
              </li>
            </ul>
          </div>

          {/* More Links */}
          <div data-id="element-172">
            <h4 className="font-extrabold text-white mb-6 text-lg" data-id="element-173">
              Information
            </h4>
            <ul className="space-y-4 text-sm font-medium text-white/70" data-id="element-174">
              <li data-id="element-175">
                <a href="#faqs" className="hover:text-yellow transition-colors" data-id="element-176">
                  FAQs
                </a>
              </li>
              <li data-id="element-177">
                <a href="#contact" className="hover:text-yellow transition-colors" data-id="element-178">
                  Contact
                </a>
              </li>
              <li data-id="element-179">
                <a href="/policies" className="hover:text-yellow transition-colors" data-id="element-180">
                  Policies
                </a>
              </li>
              <li data-id="element-181">
                <a href="/privacy" className="hover:text-yellow transition-colors" data-id="element-182">
                  Privacy
                </a>
              </li>
            </ul>
          </div>

          {/* Local SEO */}
          <div data-id="element-183">
            <h4 className="font-extrabold text-white mb-6 text-lg" data-id="element-184">
              Local Areas
            </h4>
            <ul className="space-y-4 text-sm font-medium text-white/70" data-id="element-185">
              <li data-id="element-186">
                <a href="#" className="hover:text-yellow transition-colors" data-id="element-187">
                  Childcare in Wyndham Vale
                </a>
              </li>
              <li data-id="element-188">
                <a href="#" className="hover:text-yellow transition-colors" data-id="element-189">
                  Childcare near Manor Lakes
                </a>
              </li>
              <li data-id="element-190">
                <a href="#" className="hover:text-yellow transition-colors" data-id="element-191">
                  Childcare near Werribee
                </a>
              </li>
              <li data-id="element-192">
                <a href="#" className="hover:text-yellow transition-colors" data-id="element-193">
                  Childcare near Tarneit
                </a>
              </li>
              <li data-id="element-194">
                <a href="#" className="hover:text-yellow transition-colors" data-id="element-195">
                  Childcare near Mambourin
                </a>
              </li>
              <li data-id="element-196">
                <a href="#" className="hover:text-yellow transition-colors" data-id="element-197">
                  Childcare near Hoppers Crossing
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Acknowledgement of Country */}
        <div className="bg-white/5 p-8 rounded-[24px] border border-white/10 mb-8" data-id="element-198">
          <h4 className="font-extrabold text-white mb-3 text-sm tracking-wider uppercase" data-id="element-199">
            Acknowledgement of Country
          </h4>
          <p className="text-sm text-white/60 leading-relaxed font-medium" data-id="element-200">
            At Funtastic Kidz Early Learning Centre, we honour and respect
            Aboriginal and Torres Strait Islander peoples as the First Peoples
            of Australia. We acknowledge the Bunurong and Wadawurrung Peoples as
            the Traditional Custodians of the land where our centre stands.
            Their deep connection to the Werribee Yalook, surrounding landscapes
            and skies has endured for generations. We pay our respects to their
            Ancestors and Elders — past, present and emerging — and recognise
            their ongoing role in caring for Country and community.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/10 text-sm font-medium text-white/40 gap-4" data-id="element-201">
          <p data-id="element-202">
            &copy; {new Date().getFullYear()} Funtastic Kidz Early Learning
            Centre. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-203">
            <a href="#" className="hover:text-white transition-colors" data-id="element-204">
              Facebook
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-205">
              Instagram
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-206">
              CareforKids
            </a>
          </div>
        </div>
      </div>
    </footer>;
}